import type { AxiosRequestConfig } from 'axios';
import { apiRoutes } from '../../api-routes';
import { apiUrl } from '../../constants';
import { httpClient } from '../../util';

export interface UpdateRecentLocationRequest {
  _id?: string;
  location?: {
    address: string;
    lat: number;
    lng: number;
  };
}

export type UpdateRecentLocationResponse = Record<string, never>;

export const updateRecentLocationFn = async (
  data: UpdateRecentLocationRequest,
  config: AxiosRequestConfig = {}
) => {
  // Validate that at least _id or location is provided
  if (!data._id && !data.location) {
    throw new Error('At least "_id" or "location" must be provided');
  }

  const response = await httpClient.put<UpdateRecentLocationResponse>(
    apiUrl + apiRoutes.place.user_places.recent_location,
    data,
    config
  );

  return response.data;
};
